import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigitalWaiverEntryList } from '../../../models/digital-waiver-entry-list';

@Component({
    selector: 'waiver-entries-quick-view',
    templateUrl: './waiver-entries-quick-view.component.html',
    styleUrls: ['./waiver-entries-quick-view.component.scss'],
    standalone: false
})
export class WaiverEntriesQuickViewComponent {
    constructor(
        public dialogRef: MatDialogRef<WaiverEntriesQuickViewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DigitalWaiverEntryList
    ) { }

    close(): void {
        this.dialogRef.close();
    }
} 